import { handleCallback } from '../utils/SessionController';
import Admin from '../views/Dashboard/Admin';
import ApplicantDetails from '../views/Dashboard/Applicant/ApplicantDetails';
import ApplicantReview from '../views/Dashboard/Applicant/ApplicantReview';
import Applicants from '../views/Dashboard/Applicants';
import ApplicantsRanked from '../views/Dashboard/ApplicantsRanked';
import ExternalUsers from '../views/Dashboard/ExternalUsers';
import CheckIn from '../views/Dashboard/CheckIn';

import DashboardLayout from '../views/Dashboard/Layout';
import Stats from '../views/Dashboard/Stats';
import Teams from '../views/Dashboard/Teams';
import AppSettings from "../views/Dashboard/AppSettings";
import UserSettings from "../views/Dashboard/UserSettings";

export default [
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: '/userSettings',
        component: UserSettings
      },
      {
        path: '/appSettings',
        component: AppSettings
      },
      {
        path: '/admin',
        component: Admin,
        admin: true
      },
      {
        path: '/checkIn',
        component: CheckIn,
      },
      {
        path: '/externalUsers',
        component: ExternalUsers,
      },
      {
        path: '/team',
        component: Teams,
      },
      {
        path: '/appRanked',
        component: ApplicantsRanked,
      },
      {
        path: '/app',
        component: Applicants,
      },
      {
        path: '/app/:id',
        component: ApplicantDetails,
        hidden: true,
        props: true,
      },
      {
        path: '/review/:id',
        component: ApplicantReview,
        hidden: true,
        props: true,
      },
      {
        path: '/callback',
        component: handleCallback,
        hidden: true,
        meta: {
          noAuth: true,
        },
      },
      {
        path: '/',
        component: Stats,
      },
    ],
  },
  { path: '*', redirect: '/' },
];
